import LevelCard from './LevelCard'

const LevelList = (props) => {
  const inputClassName = `w-16 rounded-md border border-gray-300 bg-white px-2 py-1 text-sm
    text-gray-600 hover:border-purple-400 focus:outline-none focus:ring-2
    focus:ring-purple-500 focus:border-purple-500`
  return (
    <div className="grid grid-cols-1 gap-4 md:hidden">
      {props.levels.map((row) => (
        <LevelCard
          theme={props.theme}
          key={row.Id}
          row={row}
          isEditor={props.isEditor}
          setLevels={props.setLevels}
          updateImage={props.updateImage}
          getImageUrl={props.getImageUrl}
          inputClassName={inputClassName}
          deleteLevel={props.deleteLevel}
          deleteActivity={props.deleteActivity}
        />
      ))}
    </div>
  );
};

export default LevelList;
